var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{style:(_vm.color),attrs:{"src":_vm.logo,"min-width":_vm.size,"width":_vm.size,"max-width":_vm.size,"min-height":_vm.size,"height":_vm.size,"max-height":_vm.size,"contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }